import { cx } from './cx'
import s from './Meter.module.css'

/** A tone for a meter segment — the semantic states plus the brand + a soft brand
 *  (for "committed vs consumed" style two-tone fills). */
export type MeterTone = 'brand' | 'brandsoft' | 'good' | 'warn' | 'critical' | 'neutral'
export interface MeterSegment { value: number; tone?: MeterTone; label?: string }

/**
 * A segmented progress / burn / capacity bar — the one meter used by budget burn,
 * seat usage, health, and any "part of a whole" bar. Segments fill left-to-right as
 * a share of `max`; pass `height` for a chunkier bar.
 */
export function Meter({ segments, max, height = 12, className }: {
  segments: MeterSegment[]; max: number; height?: number; className?: string
}) {
  const total = max || 1
  const pct = (v: number) => `${Math.min(100, Math.max(0, (v / total) * 100))}%`
  return (
    <div className={cx(s.track, className)} style={{ height }}>
      {segments.map((seg, i) => (
        <div key={i} className={cx(s.seg, s[seg.tone ?? 'brand'])} style={{ width: pct(seg.value) }} title={seg.label} />
      ))}
    </div>
  )
}
